<button [disabled]="this.disabled" mat-raised-button class="action-button" [ngClass]="buttonStyle">
  <img alt="image" [alt]="this.text" [src]="this.image" class="button-icon" />
  {{this.text}}
</button>